export function getBrokerLocationBySessionId(sessionId: string | null): string {
  return `/secured/user/queue/notification-user${sessionId ?? ''}`;
}
